import variables from '../variables'

import type { DatePickerOverrideToken } from './types'

const DatePicker: DatePickerOverrideToken = {
  colorBorder: variables.gray40
} as const

export default DatePicker
